import { watch, ref } from 'vue';
import i18n from '../plugins/vue-i18n';

export function getInitialValue(param, fallback){
  const url = new URL(window.location.href);
  return url.searchParams.get(param) ?? fallback;
}

function updateURLParams(param, value) {
  const url = new URL(window.location.href);
  if(value === 'null' || value === null) {
    url.searchParams.delete(param);
  } else {
    url.searchParams.set(param, value);
  }
  return window.history.replaceState({}, i18n.t('meta.og_title'), url.toString());
}

export function createRefFromUrlParam(name, fallback, deserializer){
  const serializedVal = getInitialValue(name, fallback);
  const unserializedVal = (deserializer) 
    ? deserializer(serializedVal)
    : serializedVal;
  return ref(unserializedVal);
}

export function bindRefToUrlParam(name, ref, serializer){
  watch(ref, (newVal)=>{
    const serializedVal = (serializer) 
    ? serializer(newVal)
    : newVal;
    updateURLParams(name, serializedVal);
  })
}
